import React from "react";
import {Link} from "react-router-dom";

interface BreadcrumbItem {
  title: string;
  href?: string; // Optional; if missing, it's treated as the active page
}

interface AppBreadcrumbProps {
  items: BreadcrumbItem[];
}

const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({ items }) => {
  const lastIndex = items.length - 1;

  
  return (
    <nav className="gg-breadcrumb" aria-label="breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, index) =>
          index !== lastIndex ? (
            <li key={index} className="breadcrumb-item">
              <Link to={item.href ?? '/'}>{item.title}</Link>
            </li>
          ) : (
            <li
              key={index}
              className="breadcrumb-item active"
              aria-current="page">
              {item.title}
            </li>
          )
        )}
      </ol>
    </nav>
  );
};

export default AppBreadcrumb;
